import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CertifiableSystem } from '@workspace-app/odatabackend/QualicoatBackendModel';

@Injectable({
  providedIn: 'root',
})
export class ApprovedSystemsGridService {
  // Subject to notify when systems data should be reloaded
  private reloadTrigger$ = new Subject<void>();

  // Subject to notify when a specific system is updated (with the updated data)
  private systemUpdated$ = new Subject<CertifiableSystem>();

  // Subject to notify when dialogs should be closed
  private closeDialogs$ = new Subject<void>();

  /**
   * Observable that emits when the systems table should reload data from server
   */
  get reloadTrigger(): Observable<void> {
    return this.reloadTrigger$.asObservable();
  }

  /**
   * Observable that emits the updated system object
   */
  get systemUpdated(): Observable<CertifiableSystem> {
    return this.systemUpdated$.asObservable();
  }

  /**
   * Observable that emits when system dialogs should be closed
   */
  get closeDialogs(): Observable<void> {
    return this.closeDialogs$.asObservable();
  }

  /**
   * Manually trigger a table reload (useful when system is updated externally)
   */
  triggerReload(): void {
    this.reloadTrigger$.next();
  }

  /**
   * Notify that a system was updated (when updated through other means)
   */
  notifySystemUpdated(system: CertifiableSystem): void {
    this.systemUpdated$.next(system);
    this.triggerReload();
  }

  /**
   * Signal to close all open dialogs
   */
  signalCloseDialogs(): void {
    this.closeDialogs$.next();
  }
}
